"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.object.to-string.js");
require("core-js/modules/es6.array.iterator.js");
require("core-js/modules/web.dom.iterable.js");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _button = _interopRequireWildcard(require("@gravity/button"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _jsxFileName = "/codebuild/output/src883409340/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/InputButton/lib/InputButton.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_krh6ybxb0() {
  var path = "/codebuild/output/src883409340/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/InputButton/lib/InputButton.js";
  var hash = "1ddc7307e1661c2f9a8211a1e9ab610d769ef092";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src883409340/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/InputButton/lib/InputButton.js",
    statementMap: {
      "0": {
        start: {
          line: 21,
          column: 16
        },
        end: {
          line: 38,
          column: 2
        }
      },
      "1": {
        start: {
          line: 40,
          column: 19
        },
        end: {
          line: 45,
          column: 1
        }
      },
      "2": {
        start: {
          line: 47,
          column: 14
        },
        end: {
          line: 54,
          column: 2
        }
      },
      "3": {
        start: {
          line: 56,
          column: 21
        },
        end: {
          line: 65,
          column: 2
        }
      },
      "4": {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 69,
          column: 17
        }
      },
      "5": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 70,
          column: 31
        }
      },
      "6": {
        start: {
          line: 72,
          column: 4
        },
        end: {
          line: 72,
          column: 43
        }
      },
      "7": {
        start: {
          line: 73,
          column: 4
        },
        end: {
          line: 73,
          column: 43
        }
      },
      "8": {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 74,
          column: 53
        }
      },
      "9": {
        start: {
          line: 79,
          column: 4
        },
        end: {
          line: 81,
          column: 5
        }
      },
      "10": {
        start: {
          line: 80,
          column: 6
        },
        end: {
          line: 80,
          column: 49
        }
      },
      "11": {
        start: {
          line: 85,
          column: 4
        },
        end: {
          line: 87,
          column: 5
        }
      },
      "12": {
        start: {
          line: 86,
          column: 6
        },
        end: {
          line: 86,
          column: 21
        }
      },
      "13": {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 91,
          column: 49
        }
      },
      "14": {
        start: {
          line: 95,
          column: 44
        },
        end: {
          line: 95,
          column: 54
        }
      },
      "15": {
        start: {
          line: 96,
          column: 4
        },
        end: {
          line: 114,
          column: 6
        }
      },
      "16": {
        start: {
          line: 100,
          column: 12
        },
        end: {
          line: 107,
          column: 14
        }
      },
      "17": {
        start: {
          line: 118,
          column: 0
        },
        end: {
          line: 131,
          column: 2
        }
      },
      "18": {
        start: {
          line: 133,
          column: 0
        },
        end: {
          line: 141,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 68,
            column: 2
          },
          end: {
            line: 68,
            column: 3
          }
        },
        loc: {
          start: {
            line: 68,
            column: 21
          },
          end: {
            line: 75,
            column: 3
          }
        },
        line: 68
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 77,
            column: 2
          },
          end: {
            line: 77,
            column: 3
          }
        },
        loc: {
          start: {
            line: 77,
            column: 12
          },
          end: {
            line: 82,
            column: 3
          }
        },
        line: 77
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 84,
            column: 2
          },
          end: {
            line: 84,
            column: 3
          }
        },
        loc: {
          start: {
            line: 84,
            column: 17
          },
          end: {
            line: 88,
            column: 3
          }
        },
        line: 84
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 90,
            column: 2
          },
          end: {
            line: 90,
            column: 3
          }
        },
        loc: {
          start: {
            line: 90,
            column: 22
          },
          end: {
            line: 92,
            column: 3
          }
        },
        line: 90
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 94,
            column: 2
          },
          end: {
            line: 94,
            column: 3
          }
        },
        loc: {
          start: {
            line: 94,
            column: 11
          },
          end: {
            line: 115,
            column: 3
          }
        },
        line: 94
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 99,
            column: 11
          },
          end: {
            line: 99,
            column: 12
          }
        },
        loc: {
          start: {
            line: 100,
            column: 12
          },
          end: {
            line: 107,
            column: 14
          }
        },
        line: 100
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 79,
            column: 4
          },
          end: {
            line: 81,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 79,
            column: 4
          },
          end: {
            line: 81,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 79
      },
      "1": {
        loc: {
          start: {
            line: 79,
            column: 8
          },
          end: {
            line: 79,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 79,
            column: 8
          },
          end: {
            line: 79,
            column: 24
          }
        }, {
          start: {
            line: 79,
            column: 28
          },
          end: {
            line: 79,
            column: 51
          }
        }],
        line: 79
      },
      "2": {
        loc: {
          start: {
            line: 85,
            column: 4
          },
          end: {
            line: 87,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 85,
            column: 4
          },
          end: {
            line: 87,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 85
      },
      "3": {
        loc: {
          start: {
            line: 85,
            column: 8
          },
          end: {
            line: 85,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 85,
            column: 8
          },
          end: {
            line: 85,
            column: 32
          }
        }, {
          start: {
            line: 85,
            column: 36
          },
          end: {
            line: 85,
            column: 57
          }
        }],
        line: 85
      },
      "4": {
        loc: {
          start: {
            line: 105,
            column: 21
          },
          end: {
            line: 105,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 105,
            column: 46
          },
          end: {
            line: 105,
            column: 50
          }
        }, {
          start: {
            line: 105,
            column: 53
          },
          end: {
            line: 105,
            column: 63
          }
        }],
        line: 105
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "1ddc7307e1661c2f9a8211a1e9ab610d769ef092"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_krh6ybxb0 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_krh6ybxb0();
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Wrapper = (cov_krh6ybxb0().s[0]++, (0, _utils.withThemedStyles)(_styledComponents.default.div, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n    display: inline-block;\n    margin: 0.5rem;\n    margin-right: 3rem;\n  "])))), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n    margin: 0.5rem;\n    margin-right: 3rem;\n    display: flex;\n    flex-wrap: nowrap;\n    gap: ", "px;\n\n    @media (max-width: 768px) {\n      width: 100%;\n    }\n  "])), _themeMapper.evolutionTheme.spacings.lg))));
var inputStyle = (cov_krh6ybxb0().s[1]++, {
  height: '1.25rem',
  border: '1px solid #c4c4c4',
  borderRight: 'none',
  paddingLeft: '6.5px'
});
var Input = (cov_krh6ybxb0().s[2]++, (0, _utils.withThemedStyles)(_styledComponents.default.input, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)([""])))), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n    outline: none;\n\n    ", ";\n  "])), _utils.inputMixin))));
var SubmitButton = (cov_krh6ybxb0().s[3]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_button.default), (0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n    height: 1.49rem;\n    line-height: 0;\n    font-size: 0.75rem;\n    position: absolute;\n    padding-left: 0.15rem;\n    padding-right: 0.15rem;\n  "]))))));
var InputButton = /*#__PURE__*/function (_Component) {
  function InputButton(props) {
    var _this;
    (0, _classCallCheck2.default)(this, InputButton);
    cov_krh6ybxb0().f[0]++;
    cov_krh6ybxb0().s[4]++;
    _this = _callSuper(this, InputButton, [props]);
    cov_krh6ybxb0().s[5]++;
    _this.state = {
      value: ''
    };
    cov_krh6ybxb0().s[6]++;
    _this.onClick = _this.onClick.bind(_this);
    cov_krh6ybxb0().s[7]++;
    _this.onKeyUp = _this.onKeyUp.bind(_this);
    cov_krh6ybxb0().s[8]++;
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }
  (0, _inherits2.default)(InputButton, _Component);
  return (0, _createClass2.default)(InputButton, [{
    key: "onClick",
    value: function onClick() {
      cov_krh6ybxb0().f[1]++;
      cov_krh6ybxb0().s[9]++;
      // Check the input :
      if ((cov_krh6ybxb0().b[1][0]++, this.state.value) && (cov_krh6ybxb0().b[1][1]++, this.state.value !== '')) {
        cov_krh6ybxb0().b[0][0]++;
        cov_krh6ybxb0().s[10]++;
        this.props.onValueSubmit(this.state.value);
      } else {
        cov_krh6ybxb0().b[0][1]++;
      }
    }
  }, {
    key: "onKeyUp",
    value: function onKeyUp(event) {
      cov_krh6ybxb0().f[2]++;
      cov_krh6ybxb0().s[11]++;
      if ((cov_krh6ybxb0().b[3][0]++, this.props.submitOnEnter) && (cov_krh6ybxb0().b[3][1]++, event.key === 'Enter')) {
        cov_krh6ybxb0().b[2][0]++;
        cov_krh6ybxb0().s[12]++;
        this.onClick();
      } else {
        cov_krh6ybxb0().b[2][1]++;
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      cov_krh6ybxb0().f[3]++;
      cov_krh6ybxb0().s[13]++;
      this.setState({
        value: event.target.value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      cov_krh6ybxb0().f[4]++;
      var _ref = (cov_krh6ybxb0().s[14]++, this.props),
        themeQueries = _ref.themeQueries,
        buttonVariant = _ref.buttonVariant;
      cov_krh6ybxb0().s[15]++;
      return /*#__PURE__*/_react.default.createElement(Wrapper, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 97,
          columnNumber: 7
        }
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: this.props.inputPlaceholderId,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 98,
          columnNumber: 9
        }
      }, function (msg) {
        cov_krh6ybxb0().f[5]++;
        cov_krh6ybxb0().s[16]++;
        return /*#__PURE__*/_react.default.createElement(Input, {
          type: "text",
          placeholder: msg,
          onChange: _this2.handleChange,
          onKeyUp: _this2.onKeyUp,
          style: themeQueries.EVOLUTION ? (cov_krh6ybxb0().b[4][0]++, null) : (cov_krh6ybxb0().b[4][1]++, inputStyle),
          id: _this2.props.inputId,
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 100,
            columnNumber: 13
          }
        });
      }), /*#__PURE__*/_react.default.createElement(SubmitButton, {
        themeQueries: themeQueries,
        variant: buttonVariant,
        onClick: this.onClick,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 110,
          columnNumber: 9
        }
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: this.props.buttonMessageId,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 111,
          columnNumber: 11
        }
      })));
    }
  }]);
}(_react.Component);
cov_krh6ybxb0().s[17]++;
InputButton.propTypes = {
  /** Action to call when click the button */
  onValueSubmit: _propTypes.default.func.isRequired,
  /** Label for button */
  buttonMessageId: _propTypes.default.string,
  /** Place holder for input */
  inputPlaceholderId: _propTypes.default.string,
  /** Whether allow submit on enter press */
  submitOnEnter: _propTypes.default.bool,
  inputId: _propTypes.default.string,
  themeContext: _themeProvider.ThemeContextType,
  themeQueries: _utils.WithThemeQueriesType,
  buttonVariant: _propTypes.default.oneOf(_button.ButtonVariant.values)
};
cov_krh6ybxb0().s[18]++;
InputButton.defaultProps = {
  buttonMessageId: undefined,
  inputPlaceholderId: undefined,
  submitOnEnter: false,
  inputId: undefined,
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT,
  themeQueries: {},
  buttonVariant: _button.ButtonVariant.primary
};
var _default = exports.default = (0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)(InputButton));